import { inviteTokenFromLocation, isInvitePath, isInviteToken } from "./rules";

// The invite token arrives as /invite#<token>. It's lifted out of the URL BEFORE anything else runs
// (main.tsx), parked in sessionStorage for the Auth0 round trip, and removed once used or refused.
// The fragment is never sent to a server, and replacing the URL keeps it out of history and of any
// Referer.
const KEY = "hs.invite";

export function captureInviteFromUrl(): void {
  const { pathname, hash } = window.location;
  if (!isInvitePath(pathname)) return;
  const token = inviteTokenFromLocation(pathname, hash);
  try {
    if (token) sessionStorage.setItem(KEY, token);
  } catch {
    // Storage unavailable: the person signs in and the admin re-sends the link.
  }
  window.history.replaceState(null, "", "/");
}

export function pendingInvite(): string | null {
  try {
    const t = sessionStorage.getItem(KEY);
    return isInviteToken(t) ? t : null;
  } catch {
    return null;
  }
}

export function clearInvite(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
